import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { arrayRemove, formValueSelector } from 'redux-form';

import CategoryDetailPanel from './CategoryDetailPanel';
import {
  previousPage as previousPageAction,
  selectCategory as selectCategoryAction
} from './redux/actions/uiActions';

export function CategoryDetailPanelContainer({
  categoryDetails,
  categoryIds,
  categoryOptions,
  dispatch,
  landingPageUrls,
  leadGenerationMethodOptions,
  leadGenerationMethods,
  myArrayRemove,
  partnerNetworks,
  previousPage,
  selectCategory,
  selectedCategory
}) {
  return (
    <CategoryDetailPanel
      arrayRemove={myArrayRemove}
      categoryDetails={categoryDetails}
      categoryIds={categoryIds}
      categoryOptions={categoryOptions}
      dispatch={dispatch}
      landingPageUrls={landingPageUrls}
      leadGenerationMethodOptions={leadGenerationMethodOptions}
      leadGenerationMethods={leadGenerationMethods}
      partnerNetworks={partnerNetworks}
      previousPage={previousPage}
      selectCategory={selectCategory}
      selectedCategory={selectedCategory}
    />
  );
}

CategoryDetailPanelContainer.propTypes = {
  categoryDetails: arrayOf(shape({})).isRequired,
  categoryIds: arrayOf(number).isRequired,
  categoryOptions: arrayOf(shape({})).isRequired,
  dispatch: func.isRequired,
  landingPageUrls: arrayOf(string),
  leadGenerationMethodOptions: arrayOf(shape({})).isRequired,
  leadGenerationMethods: arrayOf(string),
  myArrayRemove: func.isRequired,
  partnerNetworks: arrayOf(string),
  previousPage: func.isRequired,
  selectCategory: func.isRequired,
  selectedCategory: shape({}).isRequired
};

CategoryDetailPanelContainer.defaultProps = {
  landingPageUrls: [],
  leadGenerationMethods: [],
  partnerNetworks: []
};

const mapStateToProps = (
  { meta: { leadGenerationMethodOptions }, ...state },
  ownProps
) => {
  const selector = formValueSelector('partnerSubmissionForm');
  const categoryDetails = selector(state, 'category_details');
  const categoryIds = selector(state, 'category_ids');

  const currentCategoryDetails = categoryDetails.find(
    (detail) => detail.category_id === ownProps.selectedCategory.value
  );

  const {
    landing_page_urls: landingPageUrls,
    lead_generation_methods: leadGenerationMethods,
    partner_networks: partnerNetworks
  } = currentCategoryDetails;

  return {
    categoryIds,
    landingPageUrls,
    leadGenerationMethodOptions,
    leadGenerationMethods,
    partnerNetworks
  };
};

export default connect(mapStateToProps, {
  myArrayRemove: arrayRemove,
  previousPage: previousPageAction,
  selectCategory: selectCategoryAction
})(CategoryDetailPanelContainer);
